import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["parentRef"];
import React from 'react';
import { createPortal } from 'react-dom';
import { PositionedTooltip } from './PositionedTooltip';
export var TooltipPortal = _ref => {
  var {
      parentRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(PositionedTooltip, _extends({
    parentRef: parentRef
  }, props)), document.body);
};
//# sourceMappingURL=TooltipPortal.js.map